export default{
    discountGroup:'Discount Group',
    discountGroupTitle: 'Title',
    discountGroupType: 'Type',
    discountGroupValue: 'Value',
    discountGroupStatus: 'Status',
    discountGroups: 'discount Groups',
    editDiscountGroup: 'edit Discount Group',
    addDiscountGroup: 'add Discount Group',
    shareType: 'Share Type',
    doctorShare: 'Doctor Share',
    hospitalShare: 'Hospital Share',
    shareTypes: 
        { hospital: 'hospital' ,
         doctor: 'doctor' ,
         doctorAndHospital: 'DoctorAndHospital' ,
         custom: 'custom' }
      
}